import { render, staticRenderFns } from "./SwiperCardLeft.vue?vue&type=template&id=016a1de2&scoped=true&lang=pug&"
import script from "./SwiperCardLeft.vue?vue&type=script&lang=ts&"
export * from "./SwiperCardLeft.vue?vue&type=script&lang=ts&"
import style0 from "./SwiperCardLeft.vue?vue&type=style&index=0&id=016a1de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a1de2",
  null
  
)

export default component.exports